import { render, staticRenderFns } from "./TaskletComponent.vue?vue&type=template&id=4d06c2fe&scoped=true&"
import script from "./TaskletComponent.vue?vue&type=script&lang=js&"
export * from "./TaskletComponent.vue?vue&type=script&lang=js&"
import style0 from "./TaskletComponent.vue?vue&type=style&index=0&id=4d06c2fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d06c2fe",
  null
  
)

export default component.exports